import React from "react";

import {appendQueryString} from "@pg-mono/request";
import {propertyOffer} from "@pg-mono/string-utils";

import {OfferLocationLinksItem} from "../../atoms/OfferListLocationLinksItem";
import {createOfferLink} from "../../helpers/create_offer_link";

interface IProps {
    relatedOffers: {
        vendor: {
            id: number;
            slug: string;
        };
        slug: string;
        id: number;
        name: string;
        stats: {
            properties_count_for_sale: number;
        } | null;
    }[];
}

export const OfferDetailLocationLinksRelatedOffers = React.memo((props: IProps) => {
    const {relatedOffers} = props;

    return (
        <>
            {relatedOffers.map((offer) => {
                const link = appendQueryString(createOfferLink(offer), {});

                const linkText = `${offer.name} (${offer.stats?.properties_count_for_sale ?? 0} ${propertyOffer.nominative(
                    offer.stats?.properties_count_for_sale ?? 0
                )})`;
                return link && <OfferLocationLinksItem linkText={linkText} url={link} key={offer.id} />;
            })}
        </>
    );
});
import React from "react";

import {appendQueryString} from "@pg-mono/request";
import {propertyOffer} from "@pg-mono/string-utils";

import {OfferLocationLinksItem} from "../../atoms/OfferListLocationLinksItem";
import {createOfferLink} from "../../helpers/create_offer_link";

interface IProps {
    relatedOffers: {
        vendor: {
            id: number;
            slug: string;
        };
        slug: string;
        id: number;
        name: string;
        stats: {
            properties_count_for_sale: number;
        } | null;
    }[];
}

export const OfferDetailLocationLinksRelatedOffers = React.memo((props: IProps) => {
    const {relatedOffers} = props;

    return (
        <>
            {relatedOffers.map((offer) => {
                const link = appendQueryString(createOfferLink(offer), {});

                const linkText = `${offer.name} (${offer.stats?.properties_count_for_sale ?? 0} ${propertyOffer.nominative(
                    offer.stats?.properties_count_for_sale ?? 0
                )})`;
                return link && <OfferLocationLinksItem linkText={linkText} url={link} key={offer.id} />;
            })}
        </>
    );
});
